export interface GameSettings {
  musicVolume: number;
  sfxVolume: number;
  particles: boolean;
  glow: boolean;
  quality: 'low' | 'medium' | 'high';
  showGrid: boolean;
  colorblindSymbols: boolean;
}

const KEY = 'pulsenetwork.settings';

export const DEFAULT_SETTINGS: GameSettings = {
  musicVolume: 0.25,
  sfxVolume: 0.7,
  particles: true,
  glow: true,
  quality: 'high',
  showGrid: true,
  colorblindSymbols: false,
};

export function loadSettings(): GameSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(s: GameSettings): void {
  localStorage.setItem(KEY, JSON.stringify(s));
}
